import {
  CaretDownFilled,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, notification, Row, Upload } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { NavBar } from '../../compnents/nav/NavBar'
import { ThemeContext } from '../../theme/ThemeContext'
import { columns } from './PartnerPlatformColumns'
import { AddPartnerPlatformModel } from './AddPartnerPlatformModel'
import styles from './PartnerPlatform.module.css'
import {
  getPartnerPlatformList,
  isOpenPartnerPlatform,
} from './PartnerPlatformSlice'
import { PartnerPlatformListParams } from '../../services/partnerPlatform'

// 代煎机构
export const PartnerPlatform = (): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [data, setData] = useState<any>()

  const [total, setTotal] = useState<any>()

  const [params, setParams] = useState<PartnerPlatformListParams>({
    size: 10,
    current: 1,
  })

  // 合作机构id
  const [partnerId, setPartnerId] = useState(0)
  // 合作平台名称
  const [platformName, setplatformName] = useState('')
  // 联系人
  const [contactName, setcontactName] = useState('')
  // 联系电话
  const [contactPhone, setcontactPhone] = useState('')
  // 备注
  const [remark, setremark] = useState('')

  const [
    isAddPartnerPlatformModel,
    setAddPartnerPlatformModelVisible,
  ] = useState(false)
  console.log(process.env.NODE_ENV)

  useEffect(() => {
    console.log(params)

    dispatch(getPartnerPlatformList({ ...params }))
      .then(unwrapResult)
      .then((res: any) => {
        setData(res.records)
        setTotal(res.total)
      })
  }, [params])

  return (
    <Col
      style={{
        height: 'calc(100% - 20px) ',
        overflow: 'hidden',
        margin: '10px 30px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <NavBar
        where={['合作平台', '']}
        buttons={
          <Button
            type='primary'
            icon={<PlusOutlined />}
            onClick={() => setAddPartnerPlatformModelVisible(true)}
          >
            新增合作平台
          </Button>
        }
        type={false}
      />
      <Col
        style={{
          flex: 1,
          overflow: 'hidden',
          backgroundColor: theme.pn,
          marginTop: 10,
          borderRadius: 10,
          padding: '10px 15px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Form
          form={form}
          autoComplete='off'
          initialValues={{}}
          onFinish={(values) =>
            setParams({
              ...params,
              ...values,
            })
          }
        >
          <Row
            justify='space-between'
            align='middle'
            style={{ marginTop: 10, marginBottom: 20, width: '100%' }}
          >
            <Form.Item name='platformName' noStyle>
              <Input
                allowClear
                placeholder='请输入合作平台名称/助记码'
                prefix={<SearchOutlined />}
                style={{ width: '315px' }}
                onChange={form.submit}
              />
            </Form.Item>
            <Button type='primary' onClick={form.submit}>
              查询
            </Button>
          </Row>
        </Form>
        <EditableList
          page={{
            items: data,
            current: params.current || 1,
            size: params.size || 10,
            total,
          }}
          style={{ color: theme.tc3 }}
          className={styles.table}
          columns={columns(
            (action, t: any) => {
              switch (action) {
                case 'toggle':
                  dispatch(isOpenPartnerPlatform(t.id))
                    .then(unwrapResult)
                    .then(() => {
                      dispatch(getPartnerPlatformList({ ...params }))
                        .then(unwrapResult)
                        .then((res: any) => {
                          setData(res.records)
                          setTotal(res.total)
                        })
                    })
                  break
                case 'manage':
                  setPartnerId(t.id)
                  setplatformName(t.platformName)
                  setcontactName(t.contactName)
                  setcontactPhone(t.contactPhone)
                  setremark(t.remark)
                  setAddPartnerPlatformModelVisible(true)
                  break
              }
            },
            (params.size || 10) * ((params.current || 1) - 1),
            theme
          )}
          onChangePage={(current: number, size?: number) => {
            setParams({
              ...params,
              current: current,
              size: size || 10,
            })
          }}
          onRow={(t: any) => ({
            onDoubleClick: () => {
              setPartnerId(t.id)
              setplatformName(t.platformName)
              setcontactName(t.contactName)
              setcontactPhone(t.contactPhone)
              setremark(t.remark)
              setAddPartnerPlatformModelVisible(true)
            },
          })}
        />
      </Col>
      <AddPartnerPlatformModel
        partnerId={partnerId}
        platformName={platformName}
        contactName={contactName}
        contactPhone={contactPhone}
        remark={remark}
        visible={isAddPartnerPlatformModel}
        onCancel={() => {
          setPartnerId(0)
          setAddPartnerPlatformModelVisible(false)
        }}
        onOk={() => {
          setPartnerId(0)
          setAddPartnerPlatformModelVisible(false)
          dispatch(getPartnerPlatformList({ ...params }))
            .then(unwrapResult)
            .then((res: any) => {
              setData(res.records)
              setTotal(res.total)
            })
        }}
      />
    </Col>
  )
}
